/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UserControllerFindOneQueryResponse, UserControllerFindOnePathParams, UserControllerFindOneQueryParams, UserControllerFindOne400, UserControllerFindOne401, UserControllerFindOne403, UserControllerFindOne404 } from "../../models/usersController/UserControllerFindOne";

function getUserControllerFindOneUrl(userId: UserControllerFindOnePathParams["userId"]) {
  const res = { method: 'GET', url: `/api/v1/users/${userId}` as const }  
  return res
}

/**
 * @summary Get a user by id
 * {@link /api/v1/users/:userId}
 */
export async function userControllerFindOne(userId: UserControllerFindOnePathParams["userId"], params?: UserControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UserControllerFindOneQueryResponse, ResponseErrorConfig<UserControllerFindOne400 | UserControllerFindOne401 | UserControllerFindOne403 | UserControllerFindOne404>, unknown>({ method : "GET", url : getUserControllerFindOneUrl(userId).url.toString(), params, ... requestConfig })  
  return res.data
}